
import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { Button } from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import Modal, { ModalActions } from 'components/Modal';
import {DeleteModalContent} from './styles';
import messages from './messages';

const DeleteConfirm = ({onDismiss,visible, onDelete, theme})=>(
  <Modal iconColor={theme['color.redDark']} icon="warningCircle" visible={visible} onDismiss={onDismiss} title={intl.formatMessage(messages.deleteVersion)}>
    <DeleteModalContent>
      {intl.formatMessage(messages.deleteConfirmText)}
    </DeleteModalContent> :
    <ModalActions scrim>
      <Button grey onClick={onDismiss}>{intl.formatMessage(messages.cancelButton)}</Button>
      <Button color={theme['color.redDark']} primary onClick={onDelete}>{intl.formatMessage(messages.deleteItem)}</Button>
    </ModalActions>
  </Modal>);

DeleteConfirm.propTypes = {
  onDismiss: PropTypes.func,
  visible: PropTypes.bool,
  onPublish: PropTypes.func,
};

export default withTheme(DeleteConfirm);
